export enum StorageKeys {
    TAKEN_REWARDS = 'taken_rewards',
    INVITED_USERS = 'invited_users',
    VISITED = 'visited',
    QUESTS_SNAPSHOT = 'quests_snapshot',
    REWARDS_SNAPSHOT = 'rewards_snapshot',
    ROLLED_REWARDS = 'rolled_rewards',
    END_NOTIFIED = 'end_notified'
}
